<div class="container p-50">
  <div nz-row nzType="flex">
    <div nz-col nzSpan="6">
      <h5>Twilio Account</h5>
      <span>
        Twilio:SID,Token and send phone number
      </span>
    </div>
    <div nz-col nzSpan="18">
      <nz-card>
        <div class="row">
          <nz-form-item class="col-md-12">
            <nz-form-label nzNoColon>Account SID</nz-form-label>
            <nz-form-control>
              <input type="text" nz-input placeholder="Please input twilio account SID" [(ngModel)]="twilioAccount">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="row">
          <nz-form-item class="col-md-12">
            <nz-form-label nzNoColon>Authentication Token</nz-form-label>
            <nz-form-control>
              <input type="text" nz-input placeholder="Please input twilio account SID" [(ngModel)]="twilioAuthToken">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="row">
          <nz-form-item class="col-md-12">
            <nz-form-label nzNoColon>Send Phone</nz-form-label>
            <nz-form-control>
              <input type="text" nz-input placeholder="Please input twilio account SID" [(ngModel)]="twilioPhone">
            </nz-form-control>
          </nz-form-item>
        </div>
      </nz-card>
    </div>
  </div>
  <nz-divider></nz-divider>
  <div nz-row nzType="flex">
    <div nz-col nzSpan="6">
      <h5>Digital Currency API Info</h5>
      <span>
        Digital currency API:URL and Key
      </span>
    </div>
    <div nz-col nzSpan="18">
      <nz-card>
        <div class="row">
          <nz-form-item class="col-md-12">
            <nz-form-label nzNoColon>URL</nz-form-label>
            <nz-form-control>
              <input type="text" nz-input placeholder="Please input API url" [(ngModel)]="digitalCurrencyPriceApiUrl">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="row">
          <nz-form-item class="col-md-12">
            <nz-form-label nzNoColon>Key</nz-form-label>
            <nz-form-control>
              <input type="text" nz-input placeholder="Please input API key" [(ngModel)]="digitalCurrencyPriceApiKey">
            </nz-form-control>
          </nz-form-item>
        </div>
      </nz-card>
    </div>
  </div>
  <nz-divider></nz-divider>
  <div nz-row nzType="flex">
    <div nz-col nzSpan="6">
      <h5>Maker Fee</h5>
      <span>
        Percent will be deducted for every completed transaction
      </span>
    </div>
    <div nz-col nzSpan="18">
      <nz-card>
        <div class="row">
          <nz-form-item class="col-md-12">
            <nz-form-label nzNoColon>Fee</nz-form-label>
            <nz-form-control>
              <input type="text" nz-input placeholder="Please input maker fee" [(ngModel)]="makerFee">
            </nz-form-control>
          </nz-form-item>
        </div>
      </nz-card>
    </div>
  </div>
  <nz-divider></nz-divider>
  <div nz-row nzType="flex">
    <div nz-col nzSpan="6">
      <h5>Digital Currency Configuration</h5>
      <span>
        Digital Currency Configuration Description
      </span>
    </div>
    <div nz-col nzSpan="18">
      <nz-card>
        <div class="row">
          <fieldset class="scheduler-border col-md-12">
            <legend class="scheduler-border">BITCOIN</legend>
            <nz-form-item class="col-md-12">
              <nz-form-label nzNoColon>API URL</nz-form-label>
              <nz-form-control>
                <input type="text" nz-input placeholder="Please input API URL" [(ngModel)]="bitcoinUrl">
              </nz-form-control>
            </nz-form-item>
            <nz-form-item class="col-md-12">
              <nz-form-label nzNoColon>API KEY</nz-form-label>
              <nz-form-control>
                <input type="text" nz-input placeholder="Please input API KEY" [(ngModel)]="bitcoinKey">
              </nz-form-control>
            </nz-form-item>
            <nz-form-item class="col-md-12">
              <nz-form-label nzNoColon>Balance Prefix</nz-form-label>
              <nz-form-control>
                <input type="text" nz-input placeholder="Please input balance prefix" [(ngModel)]="bitcoinPrefix">
              </nz-form-control>
            </nz-form-item>
          </fieldset>
        </div>
        <div class="row">
          <fieldset class="scheduler-border col-md-12">
            <legend class="scheduler-border">LTC</legend>
            <nz-form-item class="col-md-12">
              <nz-form-label nzNoColon>API URL</nz-form-label>
              <nz-form-control>
                <input type="text" nz-input placeholder="Please input API url" [(ngModel)]="ltcUrl">
              </nz-form-control>
            </nz-form-item>
          </fieldset>
        </div>
        <div class="row">
          <fieldset class="scheduler-border col-md-12">
            <legend class="scheduler-border">Etherscan</legend>
            <nz-form-item class="col-md-12">
              <nz-form-label nzNoColon>API URL</nz-form-label>
              <nz-form-control>
                <input type="text" nz-input placeholder="Please input api url" [(ngModel)]="etherscanUrl">
              </nz-form-control>
            </nz-form-item>
            <nz-form-item class="col-md-12">
              <nz-form-label nzNoColon>API KEY</nz-form-label>
              <nz-form-control>
                <input type="text" nz-input placeholder="Please input api key" [(ngModel)]="etherscanKey">
              </nz-form-control>
            </nz-form-item>
          </fieldset>
        </div>
      </nz-card>
    </div>
  </div>
  <nz-divider></nz-divider>
  <div nz-row nzType="flex">
    <div nz-col nzSpan="6">
      <h5>Crawl data time</h5>
      <span>
        Time to get transactions
      </span>
    </div>
    <div nz-col nzSpan="18">
      <nz-card>
        <div class="row">
          <nz-form-item class="col-md-12">
            <nz-form-label nzNoColon>Time(Minute)</nz-form-label>
            <nz-form-control>
              <input type="text" nz-input placeholder="Please input times" [(ngModel)]="resetTime">
            </nz-form-control>
          </nz-form-item>
        </div>
      </nz-card>
    </div>
  </div>
  <nz-divider></nz-divider>
  <div nz-row nzType="flex">
    <div nz-col nzSpan="6">
      <h5>Waiting Cancel Time</h5>
      <span>
        Time auto change Transaction status to dispute
      </span>
    </div>
    <div nz-col nzSpan="18">
      <nz-card>
        <div class="row">
          <nz-form-item class="col-md-12">
            <nz-form-label nzNoColon>Time(Minute)</nz-form-label>
            <nz-form-control>
              <input type="text" nz-input placeholder="Please input times" [(ngModel)]="waitingCancelTime">
            </nz-form-control>
          </nz-form-item>
        </div>
      </nz-card>
    </div>
  </div>
  <nz-divider></nz-divider>
  <div nz-row nzType="flex">
    <div nz-col nzSpan="6">
      <h5>Withdrawal Cancel Time</h5>
      <span>
        Time auto change status Withdrawal request to Cancel
      </span>
    </div>
    <div nz-col nzSpan="18">
      <nz-card>
        <div class="row">
          <nz-form-item class="col-md-12">
            <nz-form-label nzNoColon>Time(Minute)</nz-form-label>
            <nz-form-control>
              <input type="text" nz-input placeholder="Please input times" [(ngModel)]="withdrawalCancelTime">
            </nz-form-control>
          </nz-form-item>
        </div>
      </nz-card>
    </div>
  </div>
  <nz-divider></nz-divider>
  <div nz-row nzType="flex">
    <div nz-col nzSpan="6">
      <h5>Verify Email Time</h5>
      <span>
        Time to verify email
      </span>
    </div>
    <div nz-col nzSpan="18">
      <nz-card>
        <div class="row">
          <nz-form-item class="col-md-12">
            <nz-form-label nzNoColon>Time(Day)</nz-form-label>
            <nz-form-control>
              <input type="text" nz-input placeholder="Please input times" [(ngModel)]="verifyEmailTime">
            </nz-form-control>
          </nz-form-item>
        </div>
      </nz-card>
    </div>
  </div>
  <nz-divider></nz-divider>
  <div nz-row nzType="flex">
    <div nz-col nzSpan="6">
      <h5>Transaction Cancel Time</h5>
      <span>
        Time auto change Transaction status to Cancel
      </span>
    </div>
    <div nz-col nzSpan="18">
      <nz-card>
        <div class="row">
          <nz-form-item class="col-md-12">
            <nz-form-label nzNoColon>Time(Minute)</nz-form-label>
            <nz-form-control>
              <input type="text" nz-input placeholder="Please input times" [(ngModel)]="transactionCancelTime">
            </nz-form-control>
          </nz-form-item>
        </div>
      </nz-card>
    </div>
  </div>
  <nz-divider></nz-divider>
  <div nz-row nzType="flex">
    <div nz-col nzSpan="6">
      <h5>Cron Job time frame</h5>
      <span>
        Time auto run cron job
      </span>
    </div>
    <div nz-col nzSpan="18">
      <nz-card>
        <div class="row">
          <nz-form-item class="col-md-12">
            <nz-form-label nzNoColon>Time(Minute)</nz-form-label>
            <nz-form-control>
              <input type="text" nz-input placeholder="Please input times" [(ngModel)]="jobPeriodTime">
            </nz-form-control>
          </nz-form-item>
        </div>
      </nz-card>
    </div>
  </div>

  <div nz-row nzType="flex" nzJustify="end">
    <button nz-button nzType="primary" (click)="save()">Save</button>
  </div>
</div>
